export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: '⚡ Stop Building Every Practice From Scratch',
    description:
      'Use organized sessions, structures, drills, and templates instead of repeatedly creating everything yourself.',
  },
  {
    title: '🏐 Turn Match Problems Into Training Solutions',
    description:
      'Identify what went wrong and quickly connect it with drills, progressions, and game situations designed to address it.',
  },
  {
    title: '📋 Coach With a More Organized System',
    description:
      'Keep practices, player development, tactical priorities, match observations, and seasonal planning connected.',
  },
  {
    title: '🚀 Spend Less Time Preparing — More Time Coaching',
    description:
      'Use ready-to-coach resources so your energy goes where it matters most: your players and your team.',
  },
]
